module.exports = __webpack_public_path__ + "img/firebase.1a1dfb3f.svg";